import React from 'react';
import './TeleHealthVideoContainer.css';
import { OTSession, OTStreams, preloadScript } from 'opentok-react';
import Publisher from './tokboxComponents/Publisher';
import Subscriber from './tokboxComponents/Subscriber';

class TeleHealthVideoContainer extends React.Component {
   constructor(props) {
      super(props);
      this.state = {
         error: null,
         connected: false,
         publisherConnected: false,
         subscriberConnected: false,
      };

      this.onChangePublisherConnection = this.onChangePublisherConnection.bind(this)
      this.onChangeSubscriberConnection = this.onChangeSubscriberConnection.bind(this)

      this.onError = this.onError(this)

      this.sessionEvents = {
         sessionConnected: event => {
            this.onChangePublisherConnection(true)
            // console.log("LOG- SESSION - Session Connected", event)
         },
         sessionDisconnected: event => {
            const { clearTelehealthAppointmentCredentials } = this.props
            this.onChangePublisherConnection(false)
            clearTelehealthAppointmentCredentials()
            // console.log("LOG- SESSION - Session Disconnected", event)
         },
      };
   }

   onError(err) {
      // console.log("Session error", err)
      // this.setState({ error: `Failed to connect: ${err.message}` });
   }

   onChangePublisherConnection(status) {
      this.setState({ publisherConnected: status })
   }
   onChangeSubscriberConnection(status) {
      this.setState({ subscriberConnected: status })
   }


   render() {
      const { appointment, changePublisherStatus, changeSubscriberStatus, isPublisher, isSubscriber, publisherAudio, publisherVideo } = this.props

      return (
         <OTSession
            apiKey={this.props.apiKey}
            sessionId={this.props.sessionId}
            token={this.props.token}
            eventHandlers={this.sessionEvents}
            onError={this.onError}>

            <Publisher
               appointment={appointment}
               changePublisherStatus={changePublisherStatus}
               isPublisher={isPublisher}
               isSubscriber={isSubscriber}
               publisherConnected={this.state.publisherConnected}
               onChangePublisherConnection={this.onChangePublisherConnection} 
               publisherAudio={publisherAudio}
               publisherVideo={publisherVideo}/>
            <OTStreams>
               <Subscriber
                  appointment={appointment}
                  changeSubscriberStatus={changeSubscriberStatus}
                  isPublisher={isPublisher}
                  isSubscriber={isSubscriber}
                  subscriberConnected={this.state.subscriberConnected}
                  onChangeSubscriberConnection={this.onChangeSubscriberConnection} />
            </OTStreams>
         </OTSession>
      );
   }
}
export default preloadScript(TeleHealthVideoContainer);



// WEBPACK FOOTER //
// ./src/containers/TeleHealthVideo/TeleHealthVideoContainer.js